import { render, staticRenderFns } from "./devImportTemplate.vue?vue&type=template&id=52140776&scoped=true&"
import script from "./devImportTemplate.vue?vue&type=script&lang=js&"
export * from "./devImportTemplate.vue?vue&type=script&lang=js&"
import style0 from "./devImportTemplate.vue?vue&type=style&index=0&id=52140776&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52140776",
  null
  
)

export default component.exports